import { render, staticRenderFns } from "./RequestWorkTypeIncludedInWorkPackagesIndicator.vue?vue&type=template&id=beac1974&"
import script from "./RequestWorkTypeIncludedInWorkPackagesIndicator.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypeIncludedInWorkPackagesIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
